var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "con-box" },
    [
      _vm._l(_vm.contentArr, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "each",
            style: { width: item.width || "33.33%" }
          },
          [
            !item.hide
              ? _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    { staticClass: "key", style: { width: _vm.labelWidth } },
                    [
                      _vm._v(
                        _vm._s(item.label) +
                          _vm._s(item.hide ? "" : "：") +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  item.type == "image"
                    ? _c(
                        "div",
                        { staticClass: "value" },
                        [
                          _vm.fileArr[item.value] &&
                          _vm.fileArr[item.value].length
                            ? _c("EXPreview", {
                                attrs: { photosList: _vm.fileArr[item.value] }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : item.type == "file"
                    ? _c(
                        "div",
                        { staticClass: "value" },
                        _vm._l(_vm.fileArr[item.value], function(row) {
                          return _c("div", { key: row.id }, [
                            _c(
                              "span",
                              {
                                staticClass: "filename",
                                on: {
                                  click: function($event) {
                                    return _vm.downloadFile(row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(row.attachName))]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "size" }, [
                              _vm._v("（" + _vm._s(row.fileSize) + "kb）")
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "filename",
                                on: {
                                  click: function($event) {
                                    return _vm.previewFile(row)
                                  }
                                }
                              },
                              [_vm._v("- 预览")]
                            )
                          ])
                        }),
                        0
                      )
                    : item.type == "info"
                    ? _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: { "margin-left": "-0.86rem" },
                          style: item.infoStyle
                        },
                        [
                          _c("div", { staticClass: "table-desc" }, [
                            _c("div", { staticClass: "tips" }, [
                              _c("img", { attrs: { alt: "" } }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#333",
                                    "margin-left": "0.06rem"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.info
                                        ? item.info
                                        : _vm.getObjectProperty(
                                            _vm.detailForm,
                                            item.value
                                          )
                                    )
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "value", style: item.cssStyle },
                        [
                          item.link
                            ? _c(
                                "div",
                                {
                                  staticClass: "links",
                                  on: {
                                    click: function($event) {
                                      return _vm.gotoLink(item)
                                    }
                                  }
                                },
                                [
                                  _c("img", { attrs: { alt: "" } }),
                                  _vm._v(" "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: item.content
                                          ? item.content
                                          : _vm.getObjectProperty(
                                              _vm.detailForm,
                                              item.value
                                            ),
                                        placement: item.placement
                                          ? item.placement
                                          : "right",
                                        effect: "dark"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getObjectProperty(
                                              _vm.detailForm,
                                              item.value
                                            )
                                          ) + _vm._s(item.tag)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _c("span", { staticClass: "p" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getObjectProperty(
                                      _vm.detailForm,
                                      item.value
                                    )
                                  ) + _vm._s(item.tag)
                                )
                              ])
                        ]
                      )
                ])
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _vm.contentSize > 1 && _vm.contentIndex < _vm.contentSize - 1
        ? _c("el-divider")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, title: "预览" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e479e126", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e479e126","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXDetail/EXDetailContent.vue
// module id = 368
// module chunks = 0